import GenericGrid from 'pages/tables/GenericGrid';
import Toolbar from 'pages/tables/components/Toolbar';
import React from 'react';

export default function InventoryProductGrid(props) {
  const isStats = props.dataKey === 'Stats';
  const isDetail = props.params.includes("banniere=");

  const getStatsDetails = (d) => {
    if (d.banniere && d.sec_geo) {
      props.setParams(props.params + `banniere=${d.banniere}&sec_geo=${d.sec_geo}`);
    }
  };

  const removeDetail = () => {
    props.setParams(props.params.split("banniere=")[0]);
  };

  return (<>
    {isStats && isDetail && (<Toolbar showCreateBtn={true} txtBtn="Afficher les bannières" onCreateClick={removeDetail}></Toolbar>)}
    <GenericGrid
      canExport={true}
      autoSize={true}
      showCreateBtn={false}
      definition={props.data.meta.definition}
      data={props.data.data}
      hideToolbar={true}
      rowDoubleClicked={(d) => isStats ? getStatsDetails(d) : undefined}
    /></>
  );
}
